"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 18 10" id=icon-chevron-up><path d="M16.995 9.996a1.003 1.003 0 01-.71-.29L8.999 2.414 1.713 9.706a1.004 1.004 0 01-1.42-1.418L8.29.296a1 1 0 011.42 0l7.995 7.992a1 1 0 01-.71 1.708z"></path></symbol>';
};